// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import LookupPayrollsRequestViewModel from '../../viewModel/request/Payroll/LookupPayrollsRequestViewModel';
import GuidLookupResourceListResultViewModel from '../../viewModel/resource/GuidLookupResourceListResultViewModel';

export default (service: Servicelayer) => ({
  /**  */
  async lookupPayrolls(request: LookupPayrollsRequestViewModel, config?: RequestConfig) {
    const requestDTO = request.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-lookup-payrolls'] ?? 'Payroll';
    const response = await service.get<any>(endpointPath, {
      query: {
        zipCode: requestDTO.zipCode,
        zipCodeAddition: requestDTO.zipCodeAddition,
      },
      ...config,
    });
    const dto = response.data.result;
    return new GuidLookupResourceListResultViewModel().fromDTO(dto);
  },
});
